import { PromptStepSchema, QuestionStepSchema, StepSchema, StepType } from '@feedyou/schema'

export function isQuestionLike(step: StepSchema): step is QuestionStepSchema | PromptStepSchema
export function isQuestionLike(stepType: StepType): stepType is 'question' | 'prompt'
export function isQuestionLike(stepOrType: StepType | StepSchema) {
  const stepType = typeof stepOrType === 'string' ? stepOrType : stepOrType?.type
  return stepType === 'question' || stepType === 'prompt'
}
